/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_viewer = {
    readonly isPdpStfEnabled?: boolean | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_viewer";
};
export type PdpSharedIconBubbleEmail_viewer$data = PdpSharedIconBubbleEmail_viewer;
export type PdpSharedIconBubbleEmail_viewer$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleEmail_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isPdpStfEnabled",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "enablePdpStf"
            }
          ],
          "storageKey": "isEnabled(key:\"enablePdpStf\")"
        }
      ]
    }
  ]
};
(node as any).hash = 'b6463c146ff34b689cb50d7f9f2ddafb';
export default node;
